import axios from "axios";
import { Modal, Button } from 'react-bootstrap';
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL, generateRandomPassword } from "../../../utility";
import { useForm } from "react-hook-form";
import Loader from "../../common/Loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const EditProfile = () => {
    const [isChecked, setIsChecked] = useState(false);

    const { register, handleSubmit, reset, watch, formState: { errors }, } = useForm();

    const { id } = useParams();

    const navigate = useNavigate();

    const [user, setUser] = useState(null);
    const [flag, setFlag] = useState(2);

    const [loading, setLoading] = useState(true);

    const [showPassword, setShowPassword] = useState(false);

    const [showModal, setShowModal] = useState(false);
    
    
    useEffect(() => {
        const token = localStorage.getItem("user_token");
        // console.log("token : ", token);
        axios.get(`${API_URL}/user/profile`, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("View User res : ", res);
            setUser(res?.data?.user);
            const resObj = res?.data?.user;
            const resObj2 = res?.data;
            reset({...resObj, company_name: resObj2?.billInfo?.company_name, company_phone: resObj2?.billInfo?.company_phone, company_address: resObj2?.billInfo?.company_address, company_tax_id: resObj2?.billInfo?.company_tax_id});
            setLoading(false);
        }).catch((err) => {
            setLoading(false);
            console.log("View User error : ", err);
        })
    }, [flag])
    
    const onSubmit = (data) => {
        setLoading(true);
        console.log("data : ", data);
        const token = localStorage.getItem("user_token");
        axios.post(`${API_URL}/user/edit-profile`, {...data, user_account: user?.user_account}, {headers: {'Authorization': `Bearer ${token}`}}).then((res) => {
            console.log("User update res : ", res);
            // localStorage.setItem("admin_token", res?.data?.token);
            setLoading(false);
            toast.success("User updated successfully");
            // setTimeout(() => {
            //     navigate('/users');
            // }, 6000)
        }).catch((err) => {
            console.log("User update Error : ", err);
            // if(err?.response?.status === 500){
            //     toast.error("Server Error");
            // }
            if(err?.response?.data?.type === "API"){
                toast.error(err?.response?.data?.error);
                toast.error(err?.response?.data?.from);
            } else {
                toast.error(err?.response?.data?.error?.name ? err?.response?.data?.error?.name[0] : err?.response?.data?.error?.email ? err?.response?.data?.error?.email[0] : err?.response?.data?.error?.address ? err?.response?.data?.error?.address[0] : err?.response?.data?.error?.phone_number ? err?.response?.data?.error?.phone_number[0] : err?.response?.data?.error?.company ? err?.response?.data?.error?.company[0] : err?.response?.data?.error?.password ? err?.response?.data?.error?.password[0] : "Server Error");
            }
            setLoading(false);
            // setError(err?.response?.data?.message);
        })
    }

    // if(loading){
    //     return (
    //         <Loader />
    //     )
    // } else {
        return (
            <div className="staff-detail-page">
                <ToastContainer />
                {loading ? (<Loader />) : (
                    <>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <h1 className="staffRegNumber mt-3">Edit profile</h1>
                            <h6 className="breadCrumbs mt-4 pb-3">
                                <span onClick={() => navigate('/Setting')} className="pointer">
                                    Setting
                                </span>
                                <span className="greater-than"> &#62; </span>
                                <span className="viewVCardText">Edit profile</span>
                            </h6> 

                            <h3 className="staffdetail-sub-heading mt-4 mb-0">Information</h3>
                            <div className="d-flex mt-3">
                                <div className="divEdit w-75" style={{ maxWidth: '840px' }}>

                                    <div className="d-flex flex-row align-items-center pb-2 pt-2">
                                        <p className="displayBlockText">User account</p>
                                        <p className="displayBlockText fw-bold">{user?.user_account}</p>
                                    </div>

                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Name</p>
                                        <div className="d-flex flex-row align-items-center pe-4 mt-2 mb-2">
                                            <div className="me-2 ms-4" style={{ minWidth: '150px' }}>
                                                <input type="text"
                                                    {...register("name", { required: true })}
                                                    className="searchBox w-100" />
                                            </div>
                                            <p className="displayBlockText" style={{ minWidth: "100px" }}>Surname</p>
                                            <div className="ms-3" style={{ minWidth: '150px' }}>
                                                <input type="text" {...register("surename", { required: true })} className="searchBox w-100" />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Address</p>
                                        <p className="displayBlockText w-100">
                                            <input type="text" {...register("address", { required: true })} className="searchBox w-100" />
                                        </p>
                                    </div>

                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Email</p>
                                        <p className="displayBlockText w-100">
                                            <input type="text" {...register("email", { required: true })} className="searchBox w-100" />
                                        </p>
                                    </div>

                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Phone</p>
                                        <p className="displayBlockText w-100">
                                            <input type="text" {...register("phone_number", { required: true })} className="searchBox w-100" />
                                        </p>
                                    </div>

                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Company</p>
                                        <p className="displayBlockText w-100">
                                            <input type="text" {...register("company", { required: true })} className="searchBox w-100" />
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <h3 className="staffdetail-sub-heading mt-4 mb-0">Reset Password</h3>
                            <div className="adf d-flex w-75 mt-4 ms-4">
                                <div className="w-75 pe-2" style={{ maxWidth: '600px' }}>
                                    {/* <p className="mb-1 mt-3">Password <span className="text-danger">*</span></p> */}
                                    <div className="p-relative">
                                        <input {...register("password")} type={showPassword ? "text" : "password"} className="searchBox w-100" />
                                        <svg onClick={() => setShowPassword(!showPassword)} className="eye-iconn pointer" cla xmlns="http://www.w3.org/2000/svg" width="33.75" height="22.5" viewBox="740 700.75 33.75 22.5"><path d="M773.546 711.145c-3.178-6.2-9.468-10.395-16.671-10.395-7.203 0-13.495 4.198-16.671 10.395a1.896 1.896 0 0 0 0 1.71c3.177 6.2 9.468 10.395 16.67 10.395 7.204 0 13.496-4.198 16.672-10.395a1.895 1.895 0 0 0 0-1.71Zm-16.671 9.293a8.438 8.438 0 1 1 8.437-8.438 8.433 8.433 0 0 1-8.437 8.438Zm0-14.063c-.502.007-1.001.082-1.483.222a2.804 2.804 0 0 1-3.92 3.92 5.612 5.612 0 1 0 5.403-4.142Z" fill="#d2d2d2" fill-rule="evenodd" data-name="Icon awesome-eye" /></svg>
                                    </div>
                                </div>
                                <div className="w-fit-content mb-2">
                                    <button type="button" onClick={() => { setShowModal(true); }} className="pointerButton pe-5 ps-5 ms-4">Generate</button>
                                </div>
                            </div>

                            {/* Modal For Generate Password */}
                            <Modal show={showModal} onHide={() => setShowModal(false)} centered>
                                <Modal.Header closeButton>
                                    <Modal.Title>Confirm Password Reset</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    Are you sure you want to generate and reset the password?
                                </Modal.Body>

                                <Modal.Footer className="d-flex justify-content-center">
                                    <div className="d-flex mt-2 justify-content-center w-100">
                                        <button type="submit" className="pointerButton px-5 w-50"
                                                onClick={() => {
                                                reset({ password: generateRandomPassword(9) }); 
                                                console.log('Modal Works!');
                                                setShowModal(false);
                                                }}>Submit</button>
                                        <button className="secondaryPointerButton ms-4 px-5 w-50" type="button" onClick={() => setShowModal(false)}>Cancel</button>
                                    </div>
                                </Modal.Footer>

                            </Modal>
                                

                            <h3 className="staffdetail-sub-heading mt-4 mb-0">Bill Information</h3>
                            <div className="d-flex pt-3">
                                <div className="divEdit w-75" style={{ maxWidth: '840px' }}>
                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Company</p>
                                        <p className="displayBlockText w-100">
                                            <input type="text" {...register("company_name")} className="searchBox w-100"/>
                                        </p>
                                    </div>
                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Company Address</p>
                                        <p className="displayBlockText w-100">
                                            <input {...register("company_address")} type="text" className="searchBox w-100" />
                                        </p>
                                    </div>
                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">Phone</p>
                                        <p className="displayBlockText w-100">
                                            <input type="number" {...register("company_phone")} className="searchBox w-100" />
                                        </p>
                                    </div>
                                    <div className="d-flex flex-row align-items-center">
                                        <p className="displayBlockText">TAX ID</p>
                                        <p className="displayBlockText w-100">
                                            <input type="number" {...register("company_tax_id")} className="searchBox w-100" />
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex mt-4 mb-5">
                                <button type="submit" className="pointerButton px-5">Submit</button>
                                <button className="secondaryPointerButton ms-4 px-5" type="button" onClick={() => navigate('/setting')}>Cancel</button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        )
    // }
}

export default EditProfile;

// import React, { useState } from "react";


// const EditProfile = () => {
//     const [showPassword, setShowPassword] = useState(false);

//     return (
//         <div className="staff-detail-page edit-profile">
//             <h1 className="staffdetail-t1">Edit profile</h1>
//             <h6 className="staffdetail-t2"> Setting <span className="greater-than"> &#62; </span> <span className="staffdetail-t3">Edit Profile</span></h6>
//             <h3 className="staffdetail-sub-heading mt-4 pt-4 mb-0">Information</h3>
//             <div className="d-flex mt-4 pt-2">
//                 <div className="div1">
//                     <p className="mb-0">Status</p>
//                     <p className="mb-0">User Account</p>
//                     {/* <p className="mb-0">Wallet</p> */}
//                     <p className="mb-0">Name</p>
//                     <p className="mb-0">Address</p>
//                     <p className="mb-0">Email</p>
//                     <p className="mb-0">Phone</p>
//                     <p className="mb-0">Company</p>
//                     {/* <p className="mb-0">V-Card status</p> */}
//                 </div>
//                 <div className="div2 w-50">
//                     <p className="mb-0 color-42c78f">
//                         <div className='switch-btn-div pt-31' style={{position: 'relative', top: '-4px'}}>
//                             <input type="checkbox" defaultChecked={true}  name="check" value={true} class="toggle-station"/>                            
//                         <span className="switch-active-label">Active</span>
//                         </div>
//                     </p>
//                     <p className="mb-0">Kerry</p>
//                     <p className="mb-0 w-100">
//                         <div className="d-flex w-100" >
//                             <div className="w-50">
//                                 <input type="text" defaultValue="John" className="searchBox w-100" />
//                             </div>
//                             <div className="pt-2">
//                                 <p className="mb-0 text-normal ms-4 ps-3 me-3">Surname</p>
//                             </div>
//                             <div className="w-50">
//                                 <input type="text" defaultValue="Wick" className="searchBox w-100" />                                
//                             </div>
//                         </div>
//                     </p>
//                     <p className="mb-0 ">
//                         <input type="text" defaultValue={"1663/404 Pattanakan Road Suanluang Suanluang Bangkok 10250"} className="searchBox w-100" />                                
//                     </p>
//                     <p className="mb-0">
//                         <input type="text" defaultValue={"design@trigongroup.net"} className="searchBox w-100" />                                
//                     </p>
//                     <p className="mb-0">
//                         <input type="text" defaultValue={"038382292929"} className="searchBox w-100" />                                
//                     </p>
//                     <p className="mb-0">
//                         <input type="text" defaultValue={"Kerry Express"} className="searchBox w-100" />                                
//                     </p>
//                     {/* <p className="mb-0">
//                         <span className="color-42c78f">Verify</span>
//                         <button className="btn-2 ms-4">Re-verify</button>
//                     </p> */}
//                 </div>
//             </div>
//             <h3 className="staffdetail-sub-heading mt-4 mb-0">Reset Password</h3>
//             <div className="d-flex mt-3">
//                 <div className="w-25">
//                     <div className="p-relative">
//                         <input type={showPassword ? "text" : "password"} className="searchBox w-100" />                                
//                         <svg onClick={() => setShowPassword(!showPassword)} className="eye-iconn" xmlns="http://www.w3.org/2000/svg" width="33.75" height="22.5" viewBox="740 759.75 33.75 22.5"><path d="M773.546 770.145c-3.177-6.2-9.468-10.395-16.671-10.395-7.203 0-13.495 4.198-16.671 10.395a1.896 1.896 0 0 0 0 1.71c3.177 6.2 9.468 10.395 16.671 10.395 7.203 0 13.495-4.198 16.671-10.395a1.895 1.895 0 0 0 0-1.71Zm-16.671 9.293a8.438 8.438 0 1 1 8.438-8.438 8.433 8.433 0 0 1-8.438 8.438Zm0-14.063c-.502.007-1 .082-1.483.222a2.804 2.804 0 0 1-3.92 3.92 5.612 5.612 0 1 0 5.403-4.142Z" fill="#d2d2d2" fill-rule="evenodd" data-name="Icon awesome-eye"/></svg>
//                     </div>
//                 </div>
//                 <div>
//                     <button className="generate-pass-btn ms-3">Generate</button>
//                 </div>
//             </div>

//             <h3 className="staffdetail-sub-heading mt-4 mb-0">Bill information</h3>
//             <div className="d-flex mt-4 pt-2">
//                 <div className="div1">
//                     <p className="mb-0 mt-2">Company</p>
//                     <p className="mb-0 mt-2">Company Address</p>
//                     <p className="mb-0 mt-2">Phone</p>
//                     <p className="mb-0 mt-2">TAX ID</p>
//                 </div>
//                 <div className="div2 w-50">
//                     <p className="mb-0 mt-2">
//                         <input type="text" defaultValue={"Kerry Express"} className="searchBox w-50" />                                
//                     </p>
//                     <p className="mb-0 mt-2">
//                         <input type="text" defaultValue={"1111/105 Baangrangmuang Ladpao Road Junkasem Jatujak Bangkok 10900"} className="searchBox w-100" />                                
//                     </p>
//                     <p className="mb-0 mt-2">
//                         <input type="text" defaultValue={"025788877"} className="searchBox w-100" />                                
//                     </p>
//                     <p className="mb-0 mt-2">
//                         <input type="text" defaultValue={"1233255489966"} className="searchBox w-100" />                                
//                     </p>
                    
//                 </div>
//             </div>
//             {/* <h3 className="staffdetail-sub-heading mt-4 mb-0">Payment method</h3>
//             <div className="d-flex mt-4 pt-2">
//                 <div className="div1">
//                     <p className="mb-0">Card</p>
//                 </div>
//                 <div className="div2">
//                     <p className="mb-0">Visa ending ****9999 
//                         <span className="setting-t1">
//                             <svg xmlns="http://www.w3.org/2000/svg" width="16.293" height="16.293" viewBox="821.73 909.666 16.293 16.293"><path d="M836.064 918.627c.041-.244.041-.53.041-.814 0-.286-.041-.53-.041-.815l1.75-1.344c.166-.122.208-.326.083-.53l-1.667-2.81c-.083-.163-.333-.245-.5-.163l-2.083.814a6.064 6.064 0 0 0-1.416-.814l-.292-2.16a.446.446 0 0 0-.416-.325h-3.333a.446.446 0 0 0-.417.326l-.333 2.159c-.5.203-.958.488-1.417.814l-2.083-.814c-.208-.082-.417 0-.5.163l-1.666 2.81a.492.492 0 0 0 .083.53l1.791 1.344c0 .285-.041.53-.041.815 0 .285.041.529.041.814l-1.75 1.344c-.166.122-.207.326-.083.53l1.667 2.81c.083.164.333.245.5.164l2.083-.815c.417.326.916.61 1.416.815l.334 2.158c.041.204.208.326.416.326h3.333a.446.446 0 0 0 .417-.326l.333-2.158c.5-.204.959-.49 1.417-.815l2.083.815c.208.08.416 0 .5-.164l1.666-2.81a.491.491 0 0 0-.083-.53l-1.833-1.344Zm-6.208 2.037c-1.625 0-2.916-1.263-2.916-2.851 0-1.59 1.291-2.852 2.916-2.852s2.916 1.263 2.916 2.852c0 1.588-1.29 2.85-2.916 2.85Z" fill="#303778" fill-rule="evenodd" data-name="Icon ionic-md-settings"/></svg>
//                             Edit
//                         </span>
//                     </p>
//                 </div>
//             </div> */}
            
//             <div className="mb-5 pt-4">
//                 <button className="btn-3 mt-4">Edit</button>
//                 <button className="btn-2 ms-4">Cancel</button>
//             </div>
//         </div>
//     )
// }

// export default EditProfile;